/**
 * Labstep
 *
 * @module core/MediaQuery/Mobile
 * @desc MediaQuery for Mobile
 */

import { MediaQuery } from 'labstep-web/core/MediaQuery';
import {
  type IMediaQueryProps,
  Size,
} from 'labstep-web/core/MediaQuery/types';
import type React from 'react';

type IMediaQueryMobileProps = Omit<IMediaQueryProps, 'size'>;

export const MediaQueryMobile: React.FC<IMediaQueryMobileProps> = ({
  children,
}) => <MediaQuery size={Size.mobile}>{children}</MediaQuery>;
